import { FlexAligner, Typography } from '@scaleaq/scaleui';
import { ISensorReading, ISiteControlDeviceInfo } from '@scaleaq/sitecontrol-lib';
import { useTranslation } from 'react-i18next';

import { KeyValueRow } from '@/components/informationModal/KeyValueRow.tsx';
import { GroupBorder } from '@/styles.ts';
import { responsive } from '@/utils';

type SensorWidgetInfoFieldsProps = {
  sensor: ISiteControlDeviceInfo & ISensorReading;
};

export const SensorWidgetInfoFields = ({ sensor }: SensorWidgetInfoFieldsProps) => {
  const providerList = sensor.privateProviders ? sensor.privateProviders.join(', ') : undefined;
  const actionList = sensor.privateActions ? sensor.privateActions.join(', ') : undefined;

  const { t } = useTranslation(['bargeControl']);

  return (
    <>
      <FlexAligner direction='column' gap={responsive.spacing['large']}>
        <KeyValueRow label={t('sensorWidgetInfo.id')} value={sensor.inventoryId} />
        <GroupBorder>
          <KeyValueRow label={t('sensorWidgetInfo.name')} value={sensor.name} />
          <KeyValueRow label={t('sensorWidgetInfo.inventoryType')} value={sensor?.type} />
        </GroupBorder>
        <GroupBorder>
          <FlexAligner spaceBetween gap={responsive.spacing['6xlarge']}>
            <Typography type='body_large' style={{ whiteSpace: 'nowrap' }}>
              {t('sensorWidgetInfo.privateProviders')}
            </Typography>
            <Typography type='body_large' weight='300'>
              {providerList || t('sensorWidgetInfo.notApplicable')}
            </Typography>
          </FlexAligner>
        </GroupBorder>
        <GroupBorder>
          <FlexAligner spaceBetween gap={responsive.spacing['6xlarge']}>
            <Typography type='body_large'>{t('sensorWidgetInfo.privateActions')}</Typography>
            <Typography type='body_large' weight='300'>
              {actionList || t('sensorWidgetInfo.notApplicable')}
            </Typography>
          </FlexAligner>
        </GroupBorder>
      </FlexAligner>
    </>
  );
};
